__turbopack_context__.v({
  "className": "gamja_flower_a0ff006a-module__s-C7SG__className",
});
